'use client'

import type {ReactNode} from 'react'

type MainPaneProps = {
    children: ReactNode
}

export function MainPane({children}: MainPaneProps) {
    return (
        <main className="flex-1 min-h-0 min-w-0 bg-page overflow-hidden flex flex-col pb-14 md:pb-0">
            {children}
        </main>
    )
}
